<script setup lang="ts">
import EditUserRegisterDrawer from '@/pages/erp/du/user/view/du-userRegister-drawer.vue'
import type { UserRegisterProperties } from '@/pages/erp/du/user/db/du-userRegister-types'
import Swal from 'sweetalert2'
import {datetimeFormat} from "@/utils/deUtil";
import DuUserRegisterCompareDialog from "@/pages/erp/du/user/view/du-userRegister-compare-dialog.vue";
import DuUserRegisterDialog from "@/pages/erp/du/user/view/du-userRegister-dialog.vue";
import { onMounted, watch } from 'vue';
definePage({
    meta: {
        action: 'manage',
        subject: 'DUUSERREGISTER',
    },
})

// 核心變數初始化
const storageCompNo = useStorage('compNo', 'nstc')
if (!storageCompNo.value || storageCompNo.value === 'undefined' || storageCompNo.value === 'null') {
  storageCompNo.value = 'nstc'
}

const compNo = ref(storageCompNo.value)
const account = ref()
const username = ref()
const approveStatus = ref('W')
const depNo = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
  { title: '姓名', key: 'username' },
  { title: '單位', key: 'depNo' },
  { title: '職稱', key: 'postNo' },
  { title: '帳號', key: 'account' },
  { title: '電子郵件', key: 'email' },
  { title: '電話', key: 'phone' },
  { title: '申請時間', key: 'createdAt' },
  { title: '申請類別', key: 'createdType' },
  { title: '審核人員', key: 'approveUserId' },
  { title: '審核時間', key: 'approveAt' },
  { title: '狀態', key: 'approveStatus' },
  { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 儲存 API 回傳資料的 ref
const userRegistersData = ref<any>(null)
const isLoading = ref(false)

// 定義抓取資料的函式
const fetchUserRegisters = async () => {
  isLoading.value = true
  try {
    const url = createUrl('/du/user/userRegister/searchUserRegister', {
      query: {
        compNo: compNo.value,
        account: account.value,
        email: account.value, // 同時搜尋 Email
        username: username.value,
        depNo: depNo.value,
        approveStatus: approveStatus.value,
        page: page.value,
        size: size.value,
        orderByCol: orderByCol.value,
        sortOrder: sortOrder.value,
      },
    })
    const response = await $api(unref(url))
    userRegistersData.value = response
    console.log('fetchUserRegisters success:', response)
  } catch (error) {
    console.error('fetchUserRegisters error:', error)
  } finally {
    isLoading.value = false
  }
}

// 當搜尋條件改變時，自動觸發抓取
watch([compNo, account, username, depNo, approveStatus, page, size, orderByCol, sortOrder], () => {
  fetchUserRegisters()
}, { immediate: true })

const datas = reactive<UserRegisterProperties[]>([]);

watchEffect(() => {
  datas.splice(0, datas.length);
  if (userRegistersData.value?.data?.userRegisterPage?.content) {
    userRegistersData.value.data.userRegisterPage.content.forEach((item: UserRegisterProperties) => {
      const newItem = { ...item };
      if (newItem.createdType === 'R') {
        newItem.postNo = toCode(newItem.postNo);
        newItem.depNo = toCode(newItem.depNo);
      }
      // 只有待審核 (W) 的資料才允許被勾選
      newItem.selectable = toCode(newItem.approveStatus) === 'W';
      datas.push(newItem);
    });
  }
})



const totalDatas = computed(() => userRegistersData.value?.data?.userRegisterPage?.totalElements ?? 0)

console.log('datas: ', datas)

const isDialogVisible = ref(false)
const isCompareDialogVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}

const selected = ref([])



const editData = (userRegisterData: UserRegisterProperties) => {
  voData = userRegisterData
  console.log('editUserRegister: ', voData)
  isCompareDialogVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const registerData = ref<UserRegisterProperties>()
const updateHandler = (type: string, userRegisterData: UserRegisterProperties) => {
  console.log('updateHandler: ', type, userRegisterData)

  if (type === 'A') {
    if (!userRegisterData.depNo || !userRegisterData.postNo || !userRegisterData.account) {
      $swal({
        icon: 'error',
        title: '核准失敗',
        text: '「單位」、「職稱」、「帳號」三者皆不得為空。',
      })
      return
    }
  }

  // if (userRegisterData.createdType == 'R') {
  //   registerData.value = userRegisterData
  //   isDialogVisible.value = true
  // } else {
    userRegisterData.approveStatus = type
    updateData(userRegisterData)
  // }
}

const updateData = async (userRegisterData: UserRegisterProperties) => {
  await $api('/du/user/userRegister/updateUserRegister', {
    method: 'PUT',
    body: { userRegister: userRegisterData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
    })
  })

  // refetch data
  fetchUserRegisters()
}


const statusColor = (status: string) => {
  if (status == 'A') {
    return 'success'
  }
  if (status == 'R') {
    return 'error'
  }
  return 'info'
}

const createdTypeText = (createdType: string) => {
  if (createdType == 'R') {
    return '新註冊'
  }
  if (createdType == 'C') {
    return '資料變更'
  }
  return createdType
}

const batchUsers = ref<UserRegisterProperties[]>([])

watch(selected, (val) => {
  console.log('selected: ', val, datas.find(it => it.regId == val))
  batchUsers.value = val.map(id => {
    return datas.find(it => it.regId == id)
  }).filter((it): it is UserRegisterProperties => !!it)
  console.log('batchUsers: ', batchUsers.value)
})

const batchApprove = () => {
  console.log('batchApprove Users: ', batchUsers.value)
  
  // 檢查所有選中使用者是否都填寫了必填欄位
  const invalidUsers = batchUsers.value.filter(it => !it.depNo || !it.postNo || !it.account)
  
  if (invalidUsers.length > 0) {
    const invalidNames = invalidUsers.map(it => it.username).join(', ')
    $swal({
      icon: 'error',
      title: '批次核准失敗',
      text: `以下人員的「單位」、「職稱」或「帳號」尚未填寫：${invalidNames}`,
    })
    return
  }

  const approveUsers = batchUsers.value.map(it => {
    const user = { ...it }
    user.approveStatus = 'A'
    return user
  })

  $api('/du/user/userRegister/updateUserRegisters', {
    method: 'PUT',
    body: { userRegisters: approveUsers },
  }).then(() => {
    $swal({
      position: 'top-end',
      icon: 'success',
      title: '核准成功',
      showConfirmButton: false,
      timer: 1500,
    })
    // refetch data
    fetchUserRegisters()
  })
}

const batchReject = () => {
  console.log('batchReject Users: ', batchUsers.value)
  
  $swal({
    title: '確定要批次拒絕嗎？',
    text: `將拒絕共 ${batchUsers.value.length} 筆申請`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: '確定',
    cancelButtonText: '取消',
  }).then(async (result) => {
    if (result.isConfirmed) {
      const rejectUsers = batchUsers.value.map(it => {
        const user = { ...it }
        user.approveStatus = 'R'
        return user
      })

      $api('/du/user/userRegister/updateUserRegisters', {
        method: 'PUT',
        body: { userRegisters: rejectUsers },
      }).then(() => {
        $swal({
          position: 'top-end',
          icon: 'success',
          title: '拒絕成功',
          showConfirmButton: false,
          timer: 1500,
        })
        // refetch data
        fetchUserRegisters()
      })
    }
  })
}

const comareData = ref<UserRegisterProperties>()

const compareHandler = (userRegisterData: UserRegisterProperties) => {
  console.log('compareHandler: ', userRegisterData)
  comareData.value = userRegisterData
  isCompareDialogVisible.value = true
}

const registerApproveHandle = (userNo: string) => {
  console.log('approveHandle userNo: ', userNo)
  
  if (!registerData.value.depNo || !registerData.value.postNo || !registerData.value.account) {
    $swal({
      icon: 'error',
      title: '核准失敗',
      text: '「單位」、「職稱」、「帳號」三者皆不得為空。',
    })
    return
  }

  registerData.value.approveStatus = 'A'
  updateData( registerData.value)
}

const changeApproveHandle = () => {
  if (!comareData.value.depNo || !comareData.value.postNo || !comareData.value.account) {
    $swal({
      icon: 'error',
      title: '核准失敗',
      text: '「單位」、「職稱」、「帳號」三者皆不得為空。',
    })
    return
  }

  comareData.value.approveStatus = 'A'
  updateData(comareData.value)
}



</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppInput
            v-model="account"
            label="帳號/Email"
            type="text"
            placeholder="帳號/Email"
            :disabled="false"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppInput
            v-model="username"
            label="姓名"
            type="text"
            placeholder="姓名"
            :disabled="false"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppInput
            v-model="depNo"
            label="單位"
            type="picker"
            item-title="label"
            item-value="value"
            placeholder="單位"
            :picker="duDepartmentPicker"
            :disabled="false"
          />
        </VCol>
        <VCol
          cols="12"
          sm="2"
        >
          <AppInput
            v-model="approveStatus"
            label="審核狀態"
            type="select"
            :items="[{'value':'A','label':'通過'},{'value':'R','label':'拒絕'},{'value':'W','label':'待審核'}]"
            item-title="label"
            item-value="value"
            placeholder="請選擇審核狀態"
            :disabled="false"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-checks"
                @click="batchApprove"
                color="success"
                :disabled="batchUsers.length == 0"
        >
          批次核准
        </VBtn>
        <VBtn
                prepend-icon="tabler-x"
                @click="batchReject"
                color="error"
                :disabled="batchUsers.length == 0"
        >
          批次拒絕
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            show-select
            select-strategy="all"
            v-model="selected"
            item-selectable="selectable"
            @update:options="updateOptions"
            no-data-text="查無資料"
    >

      <template #item.account="{ item }">
          <div class="text-body-1 text-high-emphasis">
            {{ item.account }}
          </div>
      </template>
      <template #item.email="{ item }">
        <div class="text-body-1 text-high-emphasis">
          {{ item.email }}
        </div>
      </template>
      <template #item.postNo="{ item }">
        <div class="text-body-1 text-high-emphasis" v-if="item.createdType == 'R' && toCode(item.approveStatus) == 'W'">
          <AppInput
            v-model="item.postNo"
            type="select"
            :remoteItem="duPositionSelect"
            item-title="label"
            item-value="value"
            placeholder="請選擇職稱"
            style="width:200px"
          />
        </div>
        <div class="text-body-1 text-high-emphasis" v-else>
          {{ toText(item.postNo) }}
        </div>
      </template>

      <template #item.depNo="{ item }">
        <div class="text-body-1 text-high-emphasis" v-if="item.createdType == 'R' && toCode(item.approveStatus) == 'W'">
          <AppInput
            v-model="item.depNo"
            type="select"
            :remoteItem="duDepartmentSelect"
            :remoteItemParams="{ depNo: 'Z' }"
            item-title="label"
            item-value="value"
            placeholder="請選擇單位"
            style="width:200px"
          />
        </div>
          <div class="text-body-1 text-high-emphasis"  v-else>
            {{ toText(item.depNo) }}
          </div>
      </template>

      <template #item.username="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.username }}
          </div>
      </template>

      <template #item.phone="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.phone }}
          </div>
      </template>

      <template #item.createdAt="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ datetimeFormat(item.createdAt, 'YYYY/MM/DD HH:ss') }}
          </div>
      </template>

      <template #item.createdType="{ item }">
        <div class="text-body-1 text-high-emphasis">
          {{ createdTypeText(item.createdType)}}
        </div>
      </template>

      <template #item.approveUserId="{ item }">
            <div class="text-body-1 text-high-emphasis">
              {{ toText(item.approveUserId)}}
            </div>
      </template>

      <template #item.approveAt="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ datetimeFormat(item.approveAt, 'YYYY/MM/DD HH:ss') }}
          </div>
      </template>

      <template #item.approveStatus="{ item }">
        <div class="text-body-1 text-high-emphasis">
          <VChip :color="statusColor(toCode(item.approveStatus))">
            {{ toText(item.approveStatus) }}
          </VChip>
        </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
        <VBtn
          v-if="toCode(item.approveStatus) == 'W'"
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="updateHandler('A', item)"
          color="success"
        >
          核准
        </VBtn>
        <VBtn
          v-if="toCode(item.approveStatus) == 'W'"
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="updateHandler('R', item)"
          color="error"
        >
          拒絕
        </VBtn>
        <VBtn
          v-if="toCode(item.approveStatus) == 'W' && toCode(item.createdType) == 'C'"
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="compareHandler(item)"
          color="info"
        >
          檢視
        </VBtn>
        <VBtn
          v-if="toCode(item.approveStatus) == 'R'"
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="updateHandler('W', item)"
          color="primary"
        >
          重置
        </VBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <du-user-register-compare-dialog
    v-model:is-dialog-visible="isCompareDialogVisible"
    :user-register-data="comareData"
    @approve="changeApproveHandle"
  />
  <du-user-register-dialog
    v-model:is-dialog-visible="isDialogVisible"
    :user-register-data="registerData"
    @approve="registerApproveHandle"
  />

</template>
